import { render, staticRenderFns } from "./GoodsSelectDialog.vue?vue&type=template&id=6df42771&"
import script from "./GoodsSelectDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports